import {
  ApplicationRef,
  Component,
  ElementRef,
  EnvironmentInjector,
  Input,
  Renderer2,
  Type,
  ViewChild,
  createComponent,
} from "@angular/core";
import { LayoutType } from "./const";
import { ElementComponent } from "./element.component";
@Component({
  selector: "n-container",
  template: ``,
})
export class ContainerComponent extends ElementComponent {
  @Input("layout")
  layout: string;

  @Input("cols")
  gridColumns: number;

  @Input("rows")
  gridRows: number;

  constructor(
    renderer: Renderer2,
    el: ElementRef,
    private appRef: ApplicationRef,
    private injector: EnvironmentInjector
  ) {
    super(renderer, el);
  }

  refreshDisplay() {
    if (!this.el.nativeElement) {
      return;
    }
    let child = this.el.nativeElement.lastElementChild;
    while (child) {
      this.el.nativeElement.removeChild(child);
      child = this.el.nativeElement.lastElementChild;
    }
    super.refreshDisplay();
    switch (this.layout) {
      case LayoutType.Horizontal:
        this.addClassToRootElement("flex");
        this.addClassToRootElement("flex-row");
        break;
      case LayoutType.Vertical:
        this.addClassToRootElement("flex");
        this.addClassToRootElement("flex-col");
        break;
      default:
        break;
    }
    console.log("content", this.content);
    //create child components
    for (const key in this.content) {
      let clazz;
      switch (key) {
        case "n-container":
          clazz = ContainerComponent;
          break;
        default:
          break;
      }
      if (clazz) {
        const content = this.content[key];
        if (content instanceof Array) {
          console.log("clazz", content);
          for (const childContent of content) {
            this.addChildren(clazz, childContent);
            console.log("clazz child", childContent);
          }
        } else {
          this.addChildren(clazz, content);
          console.log("clazz", content);
        }
      }
    }
  }

  addChildren(clazz: Type<unknown>, content: any) {
    const componentRef = createComponent(clazz, {
      environmentInjector: this.injector,
    });
    componentRef.setInput("content", content);
    const attributes = content.attributes;
    for (const attrName in attributes) {
      componentRef.setInput(attrName, attributes[attrName]);
    }
    this.el.nativeElement.appendChild(componentRef.location.nativeElement);
    this.appRef.attachView(componentRef.hostView);
  }
}
